// src/components/ExerciseEntryPopup.js
import ExerciseForm from './ExerciseForm';
import './DataEntryPopup.css';

export default function ExerciseEntryPopup({ onClose, onSaved }) {
  return (
    <div className="popup-overlay">
      <div className="popup">
        <button className="close-button" onClick={onClose}>✖</button>
        <ExerciseForm onSaved={onSaved} />
      </div>
    </div>
  );
}
